





























import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import { VueTagsInput } from '@johmun/vue-tags-input';
import { mapGetters } from 'vuex';
import { ValidationProvider } from 'vee-validate';

@Component({
  components: {
    VueTagsInput,
    ValidationProvider,
  },
  computed: {
    ...mapGetters({
      allGenres: 'getAllGenres',
    }),
  },
})
export default class inputGenreField extends Vue {
  @Prop({
    default: () => {
      return [];
    },
  })
  readonly value!: any[];
  @Prop({ default: true }) readonly is_main!: boolean;
  public tagPlaceholder: string = '';
  allGenres!: any[];
  @Prop({ default: () => [] }) readonly errors!: string[];
  //
  @Prop({ default: '' }) private fieldId!: string;
  @Prop({ default: '' }) private label!: string;
  @Prop({ default: '' }) private sublabel!: string;
  @Prop({ default: '' }) private rules!: string;
  @Prop({ default: 'aggressive' }) private mode: string;
  // @Prop({ default: () => [] }) private errors!: string[];

  @Emit('input') genreSelectionChanged(newSelection: any) {
    let selectedTags = newSelection.map((item: any) => {
      return { uuid: item.uuid, name: item.text, is_main: this.is_main };
    });
    this.value.forEach((item: any) => {
      if (item.is_main !== this.is_main) {
        selectedTags.push(item);
      }
    });
    return selectedTags;
  }
  dark_overlay: boolean = false;

  public getSelectedGenres() {
    let result: Array<object> = [];
    if (this.value && this.value.length > 0) {
      this.value.forEach((item: any) => {
        let tmp = this.allGenres.find((genre: any) => genre.uuid === item.uuid && item.is_main === this.is_main);
        if (tmp) {
          result.push({
            text: tmp.translations[this.$i18n.locale].name,
            classes: 'tag-label-class',
            uuid: item.uuid,
            is_main: this.is_main,
          });
        }
      });
    }
    this.tagPlaceholder = result.length > 0 ? '.' : '';
    return result;
  }

  get genreTagList() {
    if (this.allGenres && this.allGenres.length) {
      let opposing: any[] = [];
      this.value.forEach((item: any) => {
        if (item.is_main !== this.is_main) {
          opposing.push(item);
        }
      });
      return this.allGenres
        .filter((item: any) => {
          let found = opposing.find((tmp: any) => {
            return tmp.uuid === item.uuid;
          });
          return found == undefined;
        })
        .map((item: any) => {
          return { text: item.translations[this.$i18n.locale].name, classes: 'tag-label-class', uuid: item.uuid };
        });
    }
    return [];
  }
  created() {
    if (this.allGenres && this.allGenres.length <= 0) {
      this.$store.dispatch('getAllGenres');
    }
  }
  maskOpen() {
    this.dark_overlay = true;
  }
  maskClose() {
    this.dark_overlay = false;
  }
  get fieldName() {
    if (!this.label) {
      return this.$t('commons.this_field');
    }
    let fieldName = this.label;
    if (this.sublabel) {
      fieldName = this.label + `(${this.sublabel})`;
    }
    return fieldName;
  }
}
